var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkerInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5187_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5L5.67338 15.0385C5.63746 14.9957 5.41223 14.6999 5.41223 14.6999C4.33141 13.2763 3.74748 11.5374 3.75001 9.75C3.75001 7.56196 4.6192 5.46354 6.16638 3.91637C7.71355 2.36919 9.81197 1.5 12 1.5C14.188 1.5 16.2865 2.36919 17.8336 3.91637C19.3808 5.46354 20.25 7.56196 20.25 9.75C20.2527 11.5367 19.6692 13.2749 18.5889 14.698L18.5878 14.6999C18.5878 14.6999 18.3628 14.9956 18.3293 15.0354L12 22.5ZM6.60938 13.7963C6.60938 13.7963 6.78443 14.0274 6.82433 14.077L12 20.1809L17.1825 14.0684C17.2154 14.027 17.3916 13.7942 17.3916 13.7942C18.2746 12.631 18.7517 11.2103 18.75 9.75C18.75 7.95979 18.0389 6.2429 16.773 4.97703C15.5071 3.71116 13.7902 3 12 3C10.2098 3 8.49291 3.71116 7.22704 4.97703C5.96117 6.2429 5.25001 7.95979 5.25001 9.75C5.24835 11.2111 5.72587 12.6325 6.60938 13.7963Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 13.5H14.25V7.5H9.75001V13.5H8.25001V7.5C8.25042 7.1023 8.40859 6.72101 8.68981 6.4398C8.97102 6.15859 9.35231 6.00042 9.75001 6H14.25C14.6477 6.00042 15.029 6.15859 15.3102 6.4398C15.5914 6.72101 15.7496 7.1023 15.75 7.5V13.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12H11.25V13.5H12.75V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 9H11.25V10.5H12.75V9Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5187_433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerInfo);
export default __webpack_public_path__ + "static/media/marker-info.f2961c5da2338a452ad16758f165a9e3.svg";
export { ForwardRef as ReactComponent };